import { apiFetch } from './api.js';

export interface ApiError {
  error: string;
  details?: string[];
}

export async function apiPost<T>(url: string, body: unknown): Promise<T> {
  const res = await apiFetch(url, {
    method: 'POST',
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = (await res.json()) as ApiError;
    throw new Error(err.error || `API error: ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export async function apiPatch<T>(url: string, body: unknown): Promise<T> {
  const res = await apiFetch(url, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = (await res.json()) as ApiError;
    throw new Error(err.error || `API error: ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export async function apiPut<T>(url: string, body: unknown): Promise<T> {
  const res = await apiFetch(url, {
    method: 'PUT',
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = (await res.json()) as ApiError;
    throw new Error(err.error || `API error: ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export async function apiDelete(url: string): Promise<void> {
  const res = await apiFetch(url, { method: 'DELETE' });
  if (!res.ok) {
    if (res.status === 204) return;
    const err = (await res.json()) as ApiError;
    throw new Error(err.error || `API error: ${res.status}`);
  }
}
